// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

// 这是可以监听来自cms端的theme注入的版本，可实时显示
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {PreviewThemeBridge} from './utils/PreviewThemeBridge';
import { startInstallCapture } from './utils/installPrompt';



// The browser offers "install" once, early in the page load: listen from the start, not from when a component mounts.
startInstallCapture();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <PreviewThemeBridge/>
  </React.StrictMode>
);

// 保留 CRA 的性能上报
reportWebVitals();
